import React from 'react';
import KeywordsSection from '../../../sections/AdminDashboard/Configuration/Keywords';

const Keywords = () => {
  return <KeywordsSection />;
};

export default Keywords;
